import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthenticationService {

  constructor(private http: HttpClient) {
  }

  login(command) {
    return this.http.post('/api/login', command);
  }

  logout() {
    document.getElementById('mainWrapper').style.backgroundColor = '';
    return this.http.post('/api/authentication/signout', {});
  }
}
